// extracted by mini-css-extract-plugin
module.exports = {"Success":"order_Success__DsKwA","Danger":"order_Danger__3q8P3","ordersummary":"order_ordersummary__2PIlI"};